module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/双摄模组3.24340141.png";